import React from 'react'
import PropTypes from 'prop-types'

function LinkButton (props) {
  function getTrackedEventClass () {
    return props.trackedEvent ? props.trackedEvent : ''
  }

  return (
    <a
      aria-label='link button'
      data-method={props.dataMethod}
      href={props.href}
      className={props.classList + ' ' + getTrackedEventClass()}
      data-source={props.dataSource}
    >
      {props.content}
    </a>
  )
}

LinkButton.propTypes = {
  href: PropTypes.string,
  content: PropTypes.array,
  dataSource: PropTypes.string,
  dataMethod: PropTypes.string,
  trackedEvent: PropTypes.string,
  classList: PropTypes.string
}

export default LinkButton
